import React, { useEffect, useState } from "react";
import GroupedBarChart from "../../../CHARTS/GroupedBarChart";

const STATrafficFlowChart = ({ data }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const raw = data;

    const monthToNum = (m) => {
      const map = {
        APR: 3,
        MAY: 4,
        JUN: 5,
        JUL: 6,
        AUG: 7,
        SEP: 8,
        OCT: 9,
        NOV: 10,
        DEC: 11,
        JAN: 0,
        FEB: 1,
        MAR: 2,
      };
      return map[m];
    };

    const grouped =
      raw &&
      raw.reduce((acc, cur) => {
        if (!acc[cur.f_year]) {
          acc[cur.f_year] = {
            tr_up: 0,
            tr_dn: 0,
            tr_pilot: 0,

            td_up: 0,
            td_dn: 0,
            td_pilot: 0,

            tt_up: 0,
            tt_dn: 0,
            tt_pilot: 0,

            totalDays: 0,
          };
        }

        acc[cur.f_year].tr_up += cur.tr_up || 0;
        acc[cur.f_year].tr_dn += cur.tr_dn || 0;
        acc[cur.f_year].tr_pilot += cur.tr_pilot || 0;

        acc[cur.f_year].td_up += cur.td_up || 0;
        acc[cur.f_year].td_dn += cur.td_dn || 0;
        acc[cur.f_year].td_pilot += cur.td_pilot || 0;

        acc[cur.f_year].tt_up += cur.tt_up || 0;
        acc[cur.f_year].tt_dn += cur.tt_dn || 0;
        acc[cur.f_year].tt_pilot += cur.tt_pilot || 0;

        const daysInMonth = new Date(
          cur.a_year,
          monthToNum(cur.a_month) + 1,
          0
        ).getDate();

        acc[cur.f_year].totalDays += daysInMonth;

        return acc;
      }, {});

    const dimensions = ["product", ...Object.keys(grouped)];

    const seriesTR = { product: "TRAIN RECEIVED" };
    const seriesTD = { product: "TRAIN DISPATCHED" };
    const seriesTT = { product: "TRAIN TRANSACTION" };

    Object.keys(grouped).forEach((fy) => {
      const g = grouped[fy];

      const trTotal = g.tr_up + g.tr_dn + g.tr_pilot;
      seriesTR[fy] = Number((trTotal / g.totalDays).toFixed(2));

      const tdTotal = g.td_up + g.td_dn + g.td_pilot;
      seriesTD[fy] = Number((tdTotal / g.totalDays).toFixed(2));

      const ttTotal = g.tt_up + g.tt_dn + g.tt_pilot;
      seriesTT[fy] = Number((ttTotal / g.totalDays).toFixed(2));
    });

    const chart1 = {
      dimensions,
      series: [seriesTR, seriesTD, seriesTT],
    };

    setChartData(chart1);
  }, [data]);

  return (
    <div>
      <h5 className="bg-dark text-white p-3 mb-5">
        STA Traffic Flow Average Per Day{" "}
        <b style={{ fontSize: "13px", color: "#7e7d7dff" }}> </b>{" "}
      </h5>

      <div>
        {" "}
        <div>
          {" "}
          {data.length > 0 && chartData && (
            <GroupedBarChart
              data={chartData}
              rotateText={0}
              from={`Block_C`}
              chartType="bar"
            />
          )}{" "}
        </div>
      </div>
    </div>
  );
};
export default STATrafficFlowChart;
